import Config from "../Config";

export const usePaymentMethods = (gateway) => {
    const processPaymentMethods = (data) => {
        const methods = data?.data?.data?.paymentMethods || [];

        const { filtered, defaultMethod } = methods.reduce(
            (result, method) => {
                if (method.upi === 1) {
                    result.filtered.push({
                        type: Config.TRANSACTION_MODES.UPI,
                        initialCharges: method.charges,
                    });
                    if (!result.defaultMethod)
                        result.defaultMethod = Config.TRANSACTION_MODES.UPI;
                }

                if (method.card === 1) {
                    result.filtered.push({
                        type: Config.TRANSACTION_MODES.CARD,
                        initialCharges: method.charges,
                    });
                    if (
                        !result.defaultMethod &&
                        result.defaultMethod !== Config.TRANSACTION_MODES.UPI
                    )
                        result.defaultMethod = Config.TRANSACTION_MODES.CARD;
                }

                if (method.netbanking === 1) {
                    result.filtered.push({
                        type: Config.TRANSACTION_MODES.NET_BANKING,
                        initialCharges: method.charges,
                    });
                    if (
                        !result.defaultMethod &&
                        result.defaultMethod !== Config.TRANSACTION_MODES.UPI &&
                        result.defaultMethod !== Config.TRANSACTION_MODES.CARD
                    )
                        result.defaultMethod = Config.TRANSACTION_MODES.NET_BANKING;
                }

                return result;
            },
            { filtered: [], defaultMethod: "" },
        );

        return { filtered, defaultMethod };
    };

    const getPaymentGateway = (paymentMethod) => {
        const gatewayFromApi = gateway;
        if (
            gatewayFromApi === Config.PAYMENT_GATEWAY.EASEBUZZ &&
            (paymentMethod === Config.TRANSACTION_MODES.UPI || paymentMethod === Config.TRANSACTION_MODES.NET_BANKING)
        ) {
            return Config.PAYMENT_GATEWAY.EASEBUZZ;
        } else if (
            gatewayFromApi === Config.PAYMENT_GATEWAY.PAYU
            &&
            (paymentMethod === Config.TRANSACTION_MODES.UPI || paymentMethod === Config.TRANSACTION_MODES.NET_BANKING)
        ) {
            return Config.PAYMENT_GATEWAY.PAYU;
        }
        return Config.PAYMENT_GATEWAY.CASHFREE;
    };

    const getIsLoading = (selectedPaymentOption, loadingStates) => {
        const selectedGateway = getPaymentGateway(selectedPaymentOption);
        if (selectedGateway === Config.PAYMENT_GATEWAY.EASEBUZZ) {
            return loadingStates?.isEasebuzzLoading || false;
        } else if (selectedGateway === Config.PAYMENT_GATEWAY.CASHFREE) {
            return loadingStates?.isCashfreeLoading || false;
        }
        return loadingStates?.isPayULoading || false;
    };

    const renderPaymentMethodLabel = (type) => {
        switch (type) {
            case Config.TRANSACTION_MODES.UPI:
                return "UPI";
            case Config.TRANSACTION_MODES.CARD:
                return "Card";
            case Config.TRANSACTION_MODES.NET_BANKING:
                return "Net Banking";
            default:
                return "Offline";
        }
    };

    const renderPaymentMethodDescription = (type) => {
        switch (type) {
            case Config.TRANSACTION_MODES.UPI:
                return "Pay instantly using your UPI ID or app";
            case Config.TRANSACTION_MODES.CARD:
                return "Use your credit or debit card";
            case Config.TRANSACTION_MODES.NET_BANKING:
                return "Pay securely using net banking";
            default:
                return "";
        }
    };

    const renderPaymentMethodIcon = (type) => {
        const { MdQrCodeScanner } = require("react-icons/md");
        const { FaRegCreditCard } = require("react-icons/fa");
        const { BsBank2 } = require("react-icons/bs");

        switch (type) {
            case Config.TRANSACTION_MODES.UPI:
                return <MdQrCodeScanner className="w-7 h-7" />;
            case Config.TRANSACTION_MODES.CARD:
                return <FaRegCreditCard className="w-7 h-7" />;
            case Config.TRANSACTION_MODES.NET_BANKING:
                return <BsBank2 className="w-7 h-7" />;
            default:
                return null;
        }
    };

    return {
        processPaymentMethods,
        getPaymentGateway,
        getIsLoading,
        renderPaymentMethodLabel,
        renderPaymentMethodDescription,
        renderPaymentMethodIcon,
    };
};